var exports = {
  "S": "DataMarqueeSection__dogvyq",
  "G": "DataMarqueeSection__Spacer__BH5OGi",
};

module.exports = exports;
